export { default } from './BoardLogo';
